import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselSlideFn = /* @__PURE__ */ createRecipe('carousel-slide', {}, [])

const carouselSlideVariantMap = {}

const carouselSlideVariantKeys = Object.keys(carouselSlideVariantMap)

export const carouselSlide = /* @__PURE__ */ Object.assign(memo(carouselSlideFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselSlide',
  __getCompoundVariantCss__: carouselSlideFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselSlideVariantKeys,
  variantMap: carouselSlideVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselSlideVariantKeys)
  },
  getVariantProps: carouselSlideFn.getVariantProps,
})